<template>
    <div>
        <el-container :style="{ height: number + 'px' }">
            <el-aside style="width:40%;border-right:1px solid #eee;">
                <!-- 查询项目组件 -->
                <projectAside :purData="purData" :userInfo="userInfo"></projectAside>
                <div>
                    <div class="h5_title">已购买项目信息</div>
                    <div ref="top">
                        <!-- :row-class-name="tableRowClassName" -->
                        <el-table ref="table" :data="tableData" style="width: 100%">
                            <el-table-column sortable prop="projectName" label="项目名称"></el-table-column>
                            <el-table-column sortable prop="projectReplenish" label="项目补充"></el-table-column>
                            <el-table-column sortable prop="createTime" label="订购日期"></el-table-column>
                            <el-table-column sortable prop="purchaseNumber" label="订购次数"></el-table-column>
                            <el-table-column sortable prop="projectAmt" label="价格"></el-table-column>
                            <el-table-column :default-sort="{prop: 'residueNumber', order: 'descending'}" prop="residueNumber" label="剩余次数"></el-table-column>
                            <el-table-column prop="musProjectReplenish" label="划扣补充"></el-table-column>
                            <el-table-column sortable prop="remark" label="备注"></el-table-column>
                        </el-table>
                        <el-pagination @current-change="pageChanged1" :current-page="counts.pagination.page" :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next" :total="counts.pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </el-aside>
            <el-container>
                <el-main class="main_font">
                    <div v-for="(item,index) in purData" :key="index">
                        <div class="row_header border_bottom el-row">
                            <div class="el-col el-col-24">
                                <div class="el-col el-col-6">项目名称</div>
                                <div class="el-col el-col-5">项目补充</div>
                                <div class="el-col el-col-4">疗程购买次/支</div>
                                <div class="el-col el-col-4">疗程收费</div>
                                <!-- <div class="el-col el-col-4">购买日期</div> -->
                                <div class="el-col el-col-5">备注</div>
                            </div>
                        </div>
                        <div class="el-row">
                            <div class="pad_10 border_bottom el-col el-col-24">
                                <div class="el-col el-col-24">
                                    <!-- 1项目名称 -->
                                    <div class="el-col el-col-6">
                                        <div>
                                            <span>{{item.projectName}}</span>
                                        </div>
                                    </div>
                                    <!-- 2项目补充 -->
                                    <div class="el-col el-col-5">
                                        <!-- <button type="button" class="el-button el-button--primary el-button--mini is-circle">
                                        <i class="el-icon-edit"></i></button> -->
                                        <el-input @input="testSX" v-model="item.projectReplenish" placeholder="请输入"></el-input>
                                    </div>
                                    <!-- 3疗程购买次/支 -->
                                    <div class="el-col el-col-4">
                                        <el-input @input="testSX" v-model="item.purchaseNumber" placeholder="请输入" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                                        <!-- <el-input-number size="mini" v-model="num" @change="handleChange" :min="1" :max="998"></el-input-number> -->
                                    </div>
                                    <!-- 4疗程收费 -->
                                    <div class="el-col el-col-4">
                                        <el-input @input="testSX" v-model="item.projectAmt" placeholder="请输入费用" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                                    </div>
                                    <!-- 5购买日期 -->
                                    <!-- <div class=" el-col el-col-4 ">
                                        <el-date-picker :picker-options="pickerOptions" style="width:160px;" @input="testSX" v-model="item.createTime" type="date" placeholder="请选择购买日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    </div> -->
                                    <!-- 6备注 -->
                                    <div class="el-col el-col-4">
                                        <el-input :disabled="item.isUpdate==true?true:false" @input="testSX" v-model="item.purchaseRemark" placeholder="请输入备注"></el-input>
                                    </div>
                                    <!-- el-col-offset-2 -->
                                    <div class=" el-col el-col-1">
                                        <button type="button" class="el-button el-button--danger el-button--mini is-circle" @click.prevent="editRemoveDomain(item, index)"><i class="el-icon-delete"></i></button>
                                    </div>
                                </div>
                                <!-- <div class="el-col el-col-24" style="margin-top: 4px;">
                                <div class="el-col el-col-4">
                                    <div class="color_red">{{item.price}}</div>
                                </div>
                                <div class="el-col el-col-20">
                                    <div class="text_right font_12"><span class="font_12">支付金额:{{item.price}}</span> </div>
                                </div>
                            </div> -->
                            </div>
                        </div>
                    </div>
                </el-main>
                <el-footer class="el-footer">
                    <el-button type="warning" @click="buy()" size="small">确定购买</el-button>
                </el-footer>
            </el-container>
        </el-container>
    </div>
</template>
<script>

import projectAside from './aside'
export default {
    props: ['tableData', 'counts', 'userInfo'],
    components: {
        projectAside
    },
    data() {
        return {
            number: 0,
            plain1: false,
            plain2: true,
            plain3: true,
            restaurants: [],
            disabled: false,
            info: '',
            purData: [],
            num: 1,
        }
    },

    created() {
        this.$nextTick(() => {
            console.log(this.tableData);
            this.number = document.documentElement.clientHeight - 150 - this.$parent.$refs.boxHeader.offsetHeight
        });
    },
    methods: {
        testSX() {
            this.$forceUpdate();
        },
        pageChanged1(page) {
            this.counts.pagination.page = page
            this.$parent.getProject(this.userInfo.ctmMobile, '', this.counts.pagination.page)
        },
        // 删除项目
        editRemoveDomain(item, listIndex) {
            // console.log(item);
            var index = this.purData.indexOf(item);
            if (index !== -1) {
                this.purData.splice(listIndex, 1)
            }
        },
        buy() {
            // console.log(this.userInfo);
            if (this.userInfo.ctmCode == undefined) {
                this.userInfo.ctmCode = this.userInfo.cadCode
            }
            // console.log(this.userInfo.ctmCode);
            this.userInfo.ctmDate = this.userInfo.sknDate
            console.log(this.userInfo);
            this.$parent.formValidate()
                .then(userInfo => {
                    let data = {
                        information: this.userInfo.information,
                        createBy: Lockr.get("skinEmpId"),//创建人
                        earId: this.userInfo.earId,
                        earName: this.userInfo.earName,
                        sknDate: this.userInfo.ctmDate,//日期
                        name: this.userInfo.ctmName,
                        cadCode: this.userInfo.ctmCode,
                        caseCode: this.userInfo.caseCode,
                        status: this.userInfo.status,//分诊状态
                        sex: this.userInfo.ctmSex,//性别
                        age: this.userInfo.ctmAge,//年龄
                        mobile: this.userInfo.ctmMobile,//电话
                        empName: this.userInfo.ctmEmpName,//咨询师姓名
                        flag: this.userInfo.flag,//客户标签
                        sknFloor: this.userInfo.sknFloor,//楼层
                        informationSource: this.userInfo.sceName,//信息来源
                        purchaseInformationList: this.purData,                    }
                    // console.log('最后提交的总数据data');
                    // console.log(data);
                    api.requestQuiet("/skn/createSknPurchaseInformation", data, (res) => {
                        if (res.result == true) {
                            // console.log(res.data);
                            this.purData = []
                            this.$parent.getProject(this.userInfo.ctmMobile, '', this.counts.pagination.page)
                            _g.toast("success", '项目购买成功');
                        } else {
                            _g.toast("error", res.errMsg);
                        }
                    }, (err) => { });
                }).catch(err => {
                    _g.toast("warning", '请完善用户信息！！！');
                })
        },
    }
}
</script>
<style scoped>
.row_header {
  background-color: #c2e0f1;
  padding: 10px;
}
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.border_bottom {
  border-bottom: 1px solid #eee;
}
.sale_content .project_right .el-main .row_header {
  background-color: #c2e0f1;
  padding: 10px;
}
.pad_10 {
  padding: 4px;
  box-sizing: border-box;
  line-height: 45px;
}
.font_12 {
  font-size: 12px !important;
}
.text_right {
  text-align: right;
}
.color_red {
  color: #fe2278 !important;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
.name {
  margin-right: 10px;
}
.main_font {
  font-size: 13px;
  font-weight: 500;
}
.el-footer {
  border-top: 1px solid #eee;
  height: 30px !important;
  text-align: right;
  line-height: 30px;
}
.h5_title {
  padding: 5px;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 12px;
}
</style>


